import { Provider } from '@fluentui/react-northstar';
import * as microsoftTeams from "@microsoft/teams-js";
import queryString from 'query-string';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Route, useLocation } from 'react-router';
import Boot from './container/Boot';
import Configure from './container/Configure';
import Home from './container/Home/index';
import InMeeting from './container/InMeeting';
import InMeetingSearch from './container/InMeetingSearch/Index';
import MyMeetings from './container/MyMeetings';
import Layout from './container/Layout';
import Login from './container/Login';
import LoginSuccess from './container/LoginSuccess';
import NotAvailable from './container/NotAvailable';
import PostMeeting from './container/PostMeeting';
import TokenView from './container/Success';
import './global.css';
import { setToken } from './store/Login/actions';
import './theme.css';
import appSetting from './utils/appSetting';
import getTheme from './utils/teams-theme-helper';
import { teamsTheme } from './store/Meeting/actions';


export const TeamsThemes = {
    contrast: "constrast",
    dark: "dark",
    default: "default"
};

export default () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const [theme, setTheme] = React.useState('');

    React.useEffect(() => {
        const data = queryString.parse(location.search);
        if (data && data['access_token']) {
            dispatch(setToken(data));
            const token = data['access_token'] as string;
            microsoftTeams.authentication.notifySuccess(token);
            return;
        }
        microsoftTeams.initialize(() => {
            microsoftTeams.getContext((data) => {
                appSetting.setConfig(data);
                setTheme(data.theme as string);
                dispatch(teamsTheme(data.theme as string));
            });
            
        });
        microsoftTeams.registerOnThemeChangeHandler(function (theme) {
            setTheme(theme as string)
            dispatch(teamsTheme(theme as string));
        });
    }, []);

    return (
        <Provider style={{ width: '100%', height: '100%' }} className={`${theme}-font-color theme-${theme}`}  theme={getTheme(theme)}>
            <Layout>
                <Route exact path='/' component={Boot} />
                <Route path='/configure' component={Configure} />
                <Route path='/notavailable' component={NotAvailable} />
                
                <Route path='/login' component={Login} />
                <Route path='/home' component={Home} />
                <Route path='/token' component={TokenView} />
                <Route path='/premeeting' component={Home} />
                <Route path='/inmeeting' component={InMeeting} />
                <Route path='/postmeeting' component={PostMeeting} />
                <Route path='/inmeetingsearch' component={InMeetingSearch} />
                <Route path='/mymeetings' component={MyMeetings} />
            </Layout>
            <Route path='/silent-end' component={LoginSuccess} />
        </Provider>
    );
};
